import { GET_REVIEWS_URL, REVIEW_URL} from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const reviewApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getReview: builder.query({
            query: ({ product_id, page = 1, limit = 6 }) => ({
                url: GET_REVIEWS_URL,
                method: 'GET',
                params: { product_id, page, limit },
            }),
            keepUnusedDataFor: 5,
        }),   
        createReview: builder.mutation({
            query: ({ data, token }) => ({
                url: REVIEW_URL,
                method: 'POST',
                body: data,
                headers: {
                    Authorization: token ? `Bearer ${token}` : '', 
                },
            }),
        }), 
        deleteReview: builder.mutation({
            query: ({ review, token }) => ({
                url: `${REVIEW_URL}/${review}`,
                method: 'DELETE',
                headers: {
                    Authorization: token ? `Bearer ${token}` : '', 
                },
            }),
        }), 
    }),
})

export const { useGetReviewQuery, useCreateReviewMutation, useDeleteReviewMutation } = reviewApiSlice;